import type { TruckConfiguration } from '#store/slices/configurationSlice'

export const lazyExportAndDownloadXlsx = async (configuration: TruckConfiguration) => {
  const module = await import('./xlsx-exporter.ts')
  const { exportAndDownloadXlsx } = module
  await exportAndDownloadXlsx(configuration)
}

export const lazyExportOptionalEquipmentAndDownloadXlsx = async (configuration: TruckConfiguration) => {
  const module = await import('./xlsx-exporter.ts')
  const { exportOptionalEquipmentAndDownloadXlsx } = module
  await exportOptionalEquipmentAndDownloadXlsx(configuration)
}
